<template>
    <v-dialog v-if="isEngravingEnabled" v-model="dialog" class="ml-0 mt-0 pt-2" width="1150">
        <template class="shipping-costs-button merchant-offer-row ml-0 pl-0" v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="ml-0 full-width engraving_button mt-2">
                <v-avatar tile size="36">
                    <img src="@/assets/engraving_badge_black_66x66.png" alt="grill-gravur" />
                </v-avatar>
                <h3 class="text-uppercase grill-gravur-text">{{ 'Engrave product' | translation }}</h3>
            </v-btn>
        </template>

        <v-card class="px-3 py-3">
            <v-form ref="engravingForm">
                <v-flex>
                    <v-btn
                        color="secondary font-weight-bold mr-0 mt-0 mb-2"
                        class="dialog_close_button"
                        fab
                        small
                        @click.stop="dialog = false"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-flex>

                <v-card-text class="engraving_header primary ml-0 mb-2 mt-5">
                    <v-flex class="engraving_title mt-1 ml-2 mr-2">
                        <span class="pt-2">
                            {{ 'Engrave product' | translation }}
                        </span>
                    </v-flex>
                    <v-flex class="engraving_description mt-1 ml-2 mr-2" style="font-size: 18px;">
                        <span>
                            {{
                                'Give your grill or accessories a personal touch, or create a distinctive gift.'
                                    | translation
                            }}
                        </span>
                    </v-flex>
                    <v-flex class="ml-2 mr-2 mb-2">
                        <span style="font-weight: 700;">
                            {{ 'Write a text and choose a font.' | translation }}
                        </span>
                    </v-flex>
                </v-card-text>

                <v-card-text
                    class="py-0 pb-2 pl-0 mt-3 pa-0"
                    style="text-align: -webkit-left;"
                    v-if="product.images.engravings_sample"
                >
                    <v-flex row v-if="!$vuetify.breakpoint.smAndDown">
                        <tr>
                            <td v-for="(productImage, index) in sampleImages" :key="index">
                                <v-img
                                    class="engraving_image"
                                    v-if="productImage"
                                    :src="productImage.original_image_path"
                                    lazy
                                    ref="image"
                                />
                            </td>
                        </tr>
                    </v-flex>

                    <v-flex row py-0 pr-0 class="dialog_fields">
                        <div v-if="$vuetify.breakpoint.smAndDown">
                            <v-carousel height="190" light hide-controls class="sample_carousel">
                                <template v-for="(productImage, index) in sampleImages">
                                    <v-carousel-item
                                        v-if="(index + 1) % sliderColumns === 1 || sliderColumns === 1"
                                        :key="index"
                                    >
                                        <v-layout row class="flex-nowrap" style="height:100%">
                                            <template v-for="(n, i) in sliderColumns">
                                                <template v-if="+index + i < sampleImages.length">
                                                    <v-flex :key="i">
                                                        <v-img
                                                            class="engraving_image_small"
                                                            v-if="sampleImages[+index + i]"
                                                            :src="sampleImages[+index + i].original_image_path"
                                                            lazy
                                                            ref="image"
                                                        />
                                                    </v-flex>
                                                </template>
                                            </template>
                                        </v-layout>
                                    </v-carousel-item>
                                </template>
                            </v-carousel>
                        </div>
                    </v-flex>
                </v-card-text>

                <v-card-text class="ml-0 mb-0 mt-5">
                    <v-flex>
                        <h3>
                            {{ 'Configuration' | translation }}
                        </h3>
                    </v-flex>
                </v-card-text>
                <v-card-text class="mt-0 pt-0">
                    <v-text-field
                        :label="$language.translate('Personal text')"
                        required
                        :counter="engravingAdditions.textLength"
                        :rules="[rules.required, rules.engravingText]"
                        v-model="buyOptionsValues.engravingText"
                    ></v-text-field>
                    <v-select
                        :label="$language.translate('Select a font')"
                        required
                        :rules="[rules.required]"
                        :items="engravingBuyOptions"
                        v-model="buyOptionsValues.engravingFont"
                    ></v-select>
                </v-card-text>

                <v-card-text>
                    <v-flex>
                        <span>
                            {{ 'Preview of your engraving' | translation }}
                        </span>
                    </v-flex>
                </v-card-text>

                <v-card-text class="engraving_upload_block ml-2">
                    <image-preview
                        :engravingPreviewActive="engravingPreviewActive"
                        :previewImage="previewImage"
                        :engraving-text="buyOptionsValues.engravingText"
                        :engraving-font="buyOptionsValues.engravingFont"
                        :engraving-font-color="engravingFontColor"
                        :font-size="getFontSize(buyOptionsValues.engravingFont)"
                    />
                </v-card-text>

                <v-card-text style="text-align: right;">
                    <v-card-text style="font-size: 24px; padding:0;">
                        <span>{{ $language.translate('Grill') }} </span>
                        <span style="font-weight: 700;">
                            {{ product.price.price | currency }}
                        </span>
                    </v-card-text>
                    <v-card-text style="font-size: 24px; padding:0;">
                        <span>+ {{ $language.translate('Gravur') }} </span>
                        <span style="font-weight: 700;">{{ engravingFee | currency }}</span>
                    </v-card-text>
                    <v-divider block class="full-width ml-0" style="border-width: 2px;" />
                    <v-card-text style="font-size: 34px; padding:0;">
                        <span>{{ $language.translate('Gesamt') }} </span>
                        <span class="font-weight-bold">
                            {{ (product.price.price + engravingFee) | currency }}
                        </span>
                        <a
                            v-if="this.$country.getCountry() !== 'DE'"
                            class="black--text font-weight-bold"
                            style="font-size: 18px;"
                        >
                            {{ 'inkl.' | translation }}
                            <span class="text-underline">{{ 'MwSt' | translation }}</span>
                        </a>
                    </v-card-text>
                </v-card-text>
                <v-checkbox
                    required
                    :rules="[rules.required]"
                    v-bind:label="'No refund message' | translation"
                    class="mb-2"
                ></v-checkbox>

                <basket-button
                    ref="addToBasketButton"
                    :buy-options="engravingOptions"
                    :disabled="basketButtonDisabled"
                    :product="product"
                    @afterAddToBasket="closeModal"
                    :handler="addToBasketHandler"
                    :large="false"
                ></basket-button>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import BasketButton from '@breakmedia/prime-vue-product/src/product-page/BasketButton';
import ImagePreview from './ImagePreview';

export default {
    data() {
        return {
            buyOptionsValues: {
                engravingText: '',
                engravingFont: '',
            },
            engravingImage: null,
            basketButtonDisabled: false,
            dialog: false,
            rules: {
                required: v => !!v || this.$language.translate('Field is required.'),
                extension: [
                    v =>
                        !v ||
                        v.name.toLowerCase().match(/(\.eps)$/) !== null ||
                        this.$language.translate('The following file types are allowed') + ': eps',
                ],
                engravingText: v =>
                    v.length <= this.engravingAdditions.textLength ||
                    this.$language.translate('Maximum characters:') + this.engravingAdditions.textLength,
            },
            sliderColumns: 2,
        };
    },
    name: 'EngravingModal',
    components: {
        ImagePreview,
        BasketButton,
    },
    props: {
        product: {
            type: Object,
        },
        currentMerchantId: {},
        currentProductId: {},
        triggerElement: String,
        disabled: Boolean,
        round: Boolean,
        depressed: Boolean,
        block: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isEngravingEnabled() {
            // Temporarily disabled engraving
            return false;
        },
        sampleImages() {
            return this.product.images.engravings_sample.slice(0, 5);
        },
        previewImage() {
            return this.product.images.engravings_preview[0];
        },
        engravingPreviewActive() {
            return this.buyOptionsValues.engravingText.length > 0 && this.buyOptionsValues.engravingFont.length > 0;
        },
        engravingType() {
            let engraving = this.product.attributes.de.engraving;
            if (engraving) {
                return Object.values(engraving)[0];
            }
            return null;
        },
        engravingFontColor() {
            let fontColor = this.product.attributes.de.engravement_font_color;
            if (fontColor) {
                return fontColor;
            }
            return 'black';
        },
        engravingBuyOptions() {
            let engravingOptions = [];
            this.product.buyOptions.forEach(buyOption => {
                if (buyOption.indexname === 'engraving-font') {
                    engravingOptions = buyOption.Values.map(value => value.name);
                }
            });
            return engravingOptions;
        },
        engravingAdditions() {
            let additions = this.product.attributesAdditions.engraving.additions;
            const engravingType = this.engravingType;
            if (engravingType && additions[engravingType]) {
                return Object.fromEntries(new URLSearchParams(additions[engravingType]));
            }

            return {
                textLength: 40,
            };
        },
        engravingFee() {
            let feeValue = 0;
            this.product.fees.forEach(fee => {
                if (fee.type.indexOf('engraving') === 0) {
                    feeValue = fee.value;
                    const price = this.product.price;
                    if (price.VAT === 0) {
                        feeValue = feeValue / ((100 + parseFloat(price.original_VAT)) / 100);
                    }
                }
            });
            return feeValue;
        },
        engravingOptions() {
            return [
                {
                    name: 'engraving',
                    Values: {
                        engravingText: {
                            name: 'engravingText',
                            value: this.buyOptionsValues.engravingText,
                        },
                        engravingFont: {
                            name: 'engravingFont',
                            value: this.buyOptionsValues.engravingFont,
                        },
                    },
                },
            ];
        },
    },
    methods: {
        formValid() {
            return this.$refs.engravingForm.validate();
        },
        closeModal() {
            this.dialog = false;
            this.buyOptionsValues.engravingText = '';
            this.buyOptionsValues.engravingFont = '';
            this.engravingImage = [];
            this.basketButtonDisabled = false;
        },
        addToBasketHandler() {
            if (!this.formValid()) {
                return false;
            }
            this.basketButtonDisabled = true;
            this.$refs.addToBasketButton.buyProduct();
            this.basketButtonDisabled = false;
        },
        getFontSize(fontName) {
            let fontSize = 57;
            for (const buyOption of this.product.buyOptions) {
                if (buyOption.indexname === 'engraving-font') {
                    const buyOptionValue = buyOption.Values.find(val => val.name === fontName);
                    if (buyOptionValue) {
                        const config = Object.fromEntries(new URLSearchParams(buyOptionValue.description));
                        if (config.fontSize) {
                            fontSize = parseInt(config.fontSize);
                        }
                    }
                    break;
                }
            }
            return fontSize;
        },
    },
};
</script>

<style scoped lang="stylus">
@import '~vuetify/src/stylus/settings/_variables.styl';
.full-width {
  width: 100%;
  padding-left: 5px;
}
.full-width >>> .v-btn__content {
  justify-content: left;
  margin: 0;
}

.v-btn.engraving_button {
  padding: 4px 5px;
  height: 36px;
@media(min-width: $grid-breakpoints.lg) {
  padding: 5px 7px;
  height: 47px;
}
}
.grill-gravur-text {
  font-size: 13px;
  text-align: center;
  width: 100%;
  justify-content: center;
@media(min-width: $grid-breakpoints.lg) {
  font-size: 18px;
  text-align: left;
  padding-left: 10px;
}
}

.engraving_header {
  color: #ffffff;
}

.engraving_title {
  font-size: 24px;
  font-weight: 600;
}

.dialog_close_button {
  position: relative;
  float: right;
}

.engraving_image {
  height: 198px;
  width: 198px;
  margin-right: 24px;
  box-shadow: 0 0 5px #c1c1c1;
}

.engraving_image_small {
  max-width: 148px;
  margin: 2px;
  box-shadow: 0 0 5px #c1c1c1;
}

.sample_carousel {
  box-shadow: none;
}
.sample_carousel >>> .v-carousel__controls {
  padding-top: 17px;
  background: none;
}
</style>
